export const PROMPTS_FILE_INSTALL_INSTRUCTIONS_URL = 'https://help.softprocorp.com/classic/0315/content/articles/uw_doc_installation.htm';
